var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import styled from 'styled-components';
import theme from '../theme';
import TrashOutlinedIcon from '../Icon/icons/TrashOutlinedIcon';
import { ListDeleteItemContext } from '../ListItem/ListItemDelete';
var TrashOutlinedIconStyled = styled(TrashOutlinedIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.MuiSvgIcon-root {\n    fill: ", ";\n    font-size: 1.4rem;\n  }\n\n  &.MuiSvgIcon-root:hover,\n  &:active {\n    fill: ", ";\n    cursor: pointer;\n  }\n\n  &.MuiSvgIcon-root:disabled {\n    fill: ", ";\n  }\n"], ["\n  &.MuiSvgIcon-root {\n    fill: ", ";\n    font-size: 1.4rem;\n  }\n\n  &.MuiSvgIcon-root:hover,\n  &:active {\n    fill: ", ";\n    cursor: pointer;\n  }\n\n  &.MuiSvgIcon-root:disabled {\n    fill: ", ";\n  }\n"])), theme.palette.error.main, theme.palette.error.dark, theme.palette.grey[300]);
var ListItemDeleteIcon = function (props) {
    var onClick = props.onClick;
    var setHover = React.useContext(ListDeleteItemContext);
    var onMouseEnter = React.useCallback(function () {
        if (setHover)
            setHover(true);
    }, []);
    var onMouseLeave = React.useCallback(function () {
        if (setHover)
            setHover(false);
    }, []);
    return (React.createElement(IconButton, { edge: "end", disableRipple: true, disableFocusRipple: true, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: onClick },
        React.createElement(TrashOutlinedIconStyled, null)));
};
export default ListItemDeleteIcon;
var templateObject_1;
